@use '@/scss/underscore' as _;

.container {
  display: flex;
  flex-direction: column;
  margin-top: _.unit(4);
  padding-bottom: _.unit(6);
}

.section {
  padding: _.unit(6) _.unit(8);
  display: flex;
  background: var(--color-layer-1);
  border-radius: 12px;

  &:not(:first-child) {
    margin-top: _.unit(4);
  }
}

.titleWrapper {
  width: 296px;
  padding-bottom: _.unit(6);
  margin-right: _.unit(14);
  flex-shrink: 0;

  > :not(:first-child) {
    margin-top: _.unit(2);
  }
}

.title {
  @include _.shimmering-animation;
  width: 200px;
  height: 20px;
}

.card {
  flex-grow: 1;

  .label {
    @include _.shimmering-animation;
    width: 250px;
    height: 16px;
    margin-bottom: _.unit(2);
  }

  .item {
    @include _.shimmering-animation;
    width: 350px;
    height: 20px;
  }

  .table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid var(--color-neutral-variant-90);
    border-radius: 8px;

    td {
      font: var(--font-body-2);
      height: 64px;
      padding: 0 _.unit(6);
      border-bottom: 1px solid var(--color-neutral-variant-90);

      &:first-child {
        max-width: 248px;
        width: 25%;

        .item {
          width: 150px;
        }
      }

      &:last-child {
        text-align: right;
        width: 25%;

        .item {
          width: 100px;
        }
      }
    }

    tr:last-child td {
      border-bottom: none;
    }
  }
}

@media screen and (max-width: 1080px) {
  .section {
    flex-direction: column;
  }

  .titleWrapper {
    width: 100%;
    margin-right: unset;
  }

  .card {
    flex-grow: unset;
  }
}
